import { FunctionComponent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material'
import { useFormik } from 'formik'
import { always, compose } from 'ramda'
import axios from 'src/utilities/http-client'

let ResetPassword: FunctionComponent = () => {
  let navigate = useNavigate()

  let [confirmation, setConfirmation] = useState<boolean>(false)
  let [errorMessage, setErrorMessage] = useState<string>('')

  let handleCloseConfirmation = () => {
    setConfirmation(false)
    navigate('/')
  }

  let form = useFormik({
    initialValues: {
      email: null,
      primaryEmail: null,
    },
    onSubmit: (values) =>
      axios
        .post('/api/request-password-reset', {
          email: values.email,
          primaryEmail: values.primaryEmail,
        })
        .then(() => setConfirmation(true))
        .catch((err) =>
          setErrorMessage(err?.response?.data ?? 'Unable to reset password'),
        ),
  })

  return (
    <>
      <Paper className="m-4 p-4 w-1/2 mx-auto">
        <Typography sx={{ mb: 1 }}>
          If you have forgotten your password, enter your username or primary
          email below and you will receive an email to recover password.
        </Typography>
        <form onSubmit={form.handleSubmit}>
          <TextField
            variant="standard"
            className="mx-2"
            label="Username"
            name="email"
            type="text"
            onChange={form.handleChange}
            error={form.touched.email && !!form.errors.email}
            helperText={form.touched.email && form.errors.email}
          />

          <TextField
            variant="standard"
            className="mx-2"
            label="Email"
            name="primaryEmail"
            type="text"
            onChange={form.handleChange}
            error={form.touched.primaryEmail && !!form.errors.primaryEmail}
            helperText={form.touched.primaryEmail && form.errors.primaryEmail}
          />

          <div className="flex justify-end">
            <Button
              variant="outlined"
              className="mt-4 mr-3"
              onClick={compose(navigate, always('/') as any) as any}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className="mt-4 mr-3"
              disabled={!form.values.email && !form.values.primaryEmail}
            >
              Submit
            </Button>
          </div>
        </form>
      </Paper>
      <Dialog open={confirmation} onClose={handleCloseConfirmation}>
        <DialogContent>
          You should receive an email shortly with instructions for resetting
          your password. If you do not, please contact support@foamfrat.com for
          further assistance.
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCloseConfirmation}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={!!errorMessage} onClose={() => setErrorMessage('')}>
        <Alert
          variant="filled"
          onClose={() => setErrorMessage('')}
          severity="error"
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default ResetPassword
